var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Divider, Card, Grid } from '@mui/material';
import { offerList as offerListApi } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import Order from '../Order';
import { useRoaster } from '../../hooks/useRoaster';
import OfferListStoryFab from '../molecules/OfferListStoryFab';
import OfferListMaterialFab from '../molecules/OfferListMaterialFab';
import ForumFab from '../molecules/ForumFab';
import ProducerImageAvatar from '../organisms/ProducerImageAvatar';
var RoasterOrderPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var t = useTranslation().t;
    var _b = React.useState(), offerList = _b[0], setOfferList = _b[1];
    var getOfferList = useRequest(offerListApi.get);
    var roaster = useRoaster().roaster;
    var title = React.useMemo(function () {
        if (!offerList)
            return '';
        var offerListTitle = "".concat(t("countries.".concat(offerList.producer.country), {
            lng: 'en',
        }), " ").concat(offerList.name);
        return offerListTitle;
    }, [t, offerList]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getOfferList({
                            id: id,
                            with_transport_to_warehouses: true,
                            with_summary_on_last_year: true,
                        })];
                    case 1:
                        response = _a.sent();
                        if (canceled || !response)
                            return [2 /*return*/];
                        setOfferList(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getOfferList]);
    if (!offerList || !roaster)
        return null;
    var _c = offerList.allSampleOrdersCount, allSampleOrdersCount = _c === void 0 ? 0 : _c, _d = offerList.allOrderedRoasterCount, allOrderedRoasterCount = _d === void 0 ? 0 : _d;
    return (React.createElement(Box, { sx: { px: { xs: 2, md: 5 } } },
        React.createElement(Grid, { container: true, spacing: 4, alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12, md: 7 },
                React.createElement(Stack, { direction: "column", spacing: 1, mt: 4 },
                    React.createElement(ProducerImageAvatar, { offerList: offerList, sx: {
                            width: {
                                xs: 64,
                                md: 96,
                            },
                            height: {
                                xs: 64,
                                md: 96,
                            },
                        } }),
                    React.createElement(Box, { component: "h4", sx: { typography: function (theme) { return theme.customTypography.h4; } } }, title),
                    React.createElement(Stack, { direction: "row", spacing: 2, sx: { mt: 1 } },
                        React.createElement(ForumFab, { offerListId: offerList.id, role: "roaster" }),
                        React.createElement(Divider, { orientation: "vertical", sx: { borderStyle: 'dashed' }, flexItem: true }),
                        React.createElement(OfferListMaterialFab, { offerList: offerList, showTitle: true }),
                        React.createElement(OfferListStoryFab, { offerList: offerList, showTitle: true })))),
            allSampleOrdersCount > 0 && allOrderedRoasterCount > 0 && (React.createElement(Grid, { item: true, xs: 12, md: 5 },
                React.createElement(Card, { sx: { py: { xs: 3, md: 4 } } },
                    React.createElement(Stack, { direction: "row", divider: React.createElement(Divider, { orientation: "vertical", flexItem: true }) },
                        React.createElement(Stack, { width: 1, textAlign: "center" },
                            React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.h4; } } }, allSampleOrdersCount.toLocaleString()),
                            React.createElement(Box, { sx: {
                                    color: function (theme) { return theme.customPalette.text.secondary; },
                                    typography: function (theme) { return theme.customTypography.body2; },
                                } }, t('pages.roasterOrder.sampleStats'))),
                        React.createElement(Stack, { width: 1, textAlign: "center" },
                            React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.h4; } } }, allOrderedRoasterCount.toLocaleString()),
                            React.createElement(Box, { sx: {
                                    color: function (theme) { return theme.customPalette.text.secondary; },
                                    typography: function (theme) { return theme.customTypography.body2; },
                                } }, t('pages.roasterOrder.preorderStats')))))))),
        React.createElement(Order, { currentUserRole: "roaster", roaster: roaster, offerList: offerList, itemType: "Offer", items: offerList.offers })));
};
export default RoasterOrderPage;
